import { render, staticRenderFns } from "./teamSize.vue?vue&type=template&id=29cbf932&scoped=true"
import script from "./teamSize.vue?vue&type=script&lang=js"
export * from "./teamSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbf932",
  null
  
)

export default component.exports